export default __webpack_public_path__ + "static/media/s7.1b01a5ee.jpg";